import { BreadcrumbsItem } from './BreadcrumbsItem';
import { BreadcrumbsRoot } from './BreadcrumbsRoot';

export const Breadcrumbs = {
  Root: BreadcrumbsRoot,
  Item: BreadcrumbsItem,
} as const;
